import { NumberFormat, USER_FORMAT } from '@agilox/ui-common';
import { DecimalPipe } from '@angular/common';
import { inject, Inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'customNumber',
})
export class CustomNumberPipe implements PipeTransform {
	@Inject(USER_FORMAT) private userFormat = inject(USER_FORMAT);
	private decimalPipe: DecimalPipe = inject(DecimalPipe);

	transform(value: number | string | undefined | null, digitInfo?: string): any {
		if (value === undefined || value === null) {
			return undefined;
		}
		value = Number(value);

		// Use Angular's DecimalPipe to apply the basic formatting
		let decimalFormatted = this.decimalPipe.transform(value, digitInfo ? digitInfo : '1.2-2', 'de');

		if (decimalFormatted === null) {
			return decimalFormatted;
		}

		const commaIndex = decimalFormatted.indexOf(',');
		if (commaIndex > -1) {
			const isInteger = decimalFormatted
				.substring(commaIndex + 1)
				.split('')
				.every((char) => char === '0');

			if (isInteger) {
				decimalFormatted = decimalFormatted.substring(0, commaIndex);
			}
		}

		if (!this.userFormat().number) {
			return decimalFormatted;
		}

		// Apply custom formatting based on the format enum
		switch (this.userFormat().number) {
			case NumberFormat.DOT_THOUSAND_COMMA_DECIMAL:
				return this.formatDotThousandCommaDecimal(decimalFormatted);
			case NumberFormat.COMMA_THOUSAND_DOT_DECIMAL:
				return this.formatCommaThousandDotDecimal(decimalFormatted);
			case NumberFormat.SPACE_THOUSAND_DOT_DECIMAL:
				return this.formatSpaceThousandDotDecimal(decimalFormatted);
			case NumberFormat.APOSTROPHE_THOUSAND_DOT_DECIMAL:
				return this.formatApostropheThousandDotDecimal(decimalFormatted);
			case NumberFormat.COMMA_SPACE_THOUSAND_DOT_DECIMAL:
				return this.formatCommaSpaceThousandDotDecimal(decimalFormatted);
			default:
				return decimalFormatted;
		}
	}

	private formatDotThousandCommaDecimal(value: string): string {
		// Format for `# ###,##` => thousand with dot, decimal with comma
		return value;
	}

	private formatCommaThousandDotDecimal(value: string): string {
		// Format for `#,###.##` => thousand with comma, decimal with dot
		return value.replace(/([,.])/g, (match) => (match === ',' ? '.' : ','));
	}

	private formatSpaceThousandDotDecimal(value: string): string {
		// Format for `# ###.##` => thousand with space, decimal with dot
		return value.replace(/([,.])/g, (match) => (match === ',' ? '.' : ' '));
	}

	private formatApostropheThousandDotDecimal(value: string): string {
		// Format for `#’###.##` => thousand with apostrophe, decimal with dot
		return value.replace(/([,.])/g, (match) => (match === '.' ? '’' : '.'));
	}

	private formatCommaSpaceThousandDotDecimal(value: string): string {
		// Format for `#, ###.##` => thousand with comma and space, decimal with dot
		return value.replace(/([,.])/g, (match) => (match === ',' ? '.' : ', '));
	}
}
